import { memoryTraceEventSchema, } from "./memory-trace.js";
/** Canonical admission trace construction shared by the two runtime boundaries. */
export function buildIntentionalAdmissionTraceEvents(input) {
    const common = {
        schemaVersion: 1,
        traceId: input.traceId,
        operationId: input.operationId,
        lane: "intentional",
        source: input.source,
        scope: input.scope,
    };
    return [
        ...(input.admitted.length > 0
            ? [memoryTraceEventSchema.parse({
                    ...common,
                    payload: {
                        phase: "admission",
                        result: { outcome: "admitted", memoryRefs: input.admitted },
                    },
                })]
            : []),
        ...input.rejected.flatMap((rejection) => rejection.memoryRefs.length === 0
            ? []
            : [memoryTraceEventSchema.parse({
                    ...common,
                    payload: {
                        phase: "admission",
                        result: {
                            outcome: "rejected",
                            memoryRefs: rejection.memoryRefs,
                            reason: rejection.reason,
                        },
                    },
                })]),
    ];
}
